import { ICallRecording } from '@dataTypes/calls.type'
import axios from './axiosConfig'
import { getEnv } from '@utils/env'

const CLINIC_BUSINESS_API = getEnv('REACT_APP_BUSINESS_LAYER_CLINIC')

interface ApiEnvelope<T> {
  statusCode: number
  message: string
  data: T
}

export const fetchCallRecordingSettingsApi = async (
  clinicId: string,
): Promise<ApiEnvelope<{ call_recording_settings: ICallRecording }>> => {
  const response = await axios.get<
    ApiEnvelope<{ call_recording_settings: ICallRecording }>
  >(`${CLINIC_BUSINESS_API}/api/v1/clinic/call-recording-settings/${clinicId}`)
  return response.data
}

export const saveCallRecordingSettingsApi = async (
  payload: ICallRecording,
): Promise<ApiEnvelope<{ call_recording_settings: ICallRecording }>> => {
  const response = await axios.put<
    ApiEnvelope<{ call_recording_settings: ICallRecording }>
  >(`${CLINIC_BUSINESS_API}/api/v1/clinic/call-recording-settings`, payload)
  return response.data
}
